import React from 'react';

const SidebarActions = ({actions}) => {

	return actions ? <div className="sidebar-actions-wrapper">
		<div className="sidebar-actions">
			{ actions.map( ( action, i ) => <a className="btn btn-info" target="_blank" key={i} href={action.file}>{action.label}</a> ) }
		</div>
	</div> : null;
};

export default SidebarActions;



// WEBPACK FOOTER //
// ./src/components/SidebarActions.js